export default __webpack_public_path__ + "static/media/cosmic-timetraveler-LhDWW8PhPoE-unsplash.47d84203.jpg";